/**
 * Web implementation of SecureStorage using localStorage.
 *
 * All keys are prefixed with "satsflow_" to namespace our storage.
 * This is the ONLY use of localStorage in the app -- all other persistent
 * data goes through Evolu.
 *
 * On web, the master mnemonic is stored here encrypted with the user's PIN
 * (PBKDF2 -> AES-GCM). The encryption logic is in the wallet lifecycle
 * module (Phase 2), this is just the storage layer.
 *
 * @module platform/secure-storage.web
 */

import type { SecureStorage } from './types';

/** Prefix for all localStorage keys to avoid collisions. */
const STORAGE_PREFIX = 'satsflow_';

/**
 * Create a web SecureStorage implementation using localStorage.
 *
 * @returns SecureStorage interface backed by localStorage
 */
export function createWebSecureStorage(): SecureStorage {
  return {
    store(key: string, value: string): Promise<void> {
      localStorage.setItem(`${STORAGE_PREFIX}${key}`, value);
      return Promise.resolve();
    },

    retrieve(key: string): Promise<string | null> {
      return Promise.resolve(localStorage.getItem(`${STORAGE_PREFIX}${key}`));
    },

    remove(key: string): Promise<void> {
      localStorage.removeItem(`${STORAGE_PREFIX}${key}`);
      return Promise.resolve();
    },
  };
}
